import { Controller } from '@hotwired/stimulus'
export default class extends Controller {
  static targets = [
    'submitTarget',
    'projectName',
    'todolistGroup', 'cardColumnGroup', 'messageBoardGroup', 'scheduleGroup'
  ]

  connect () {
    this.refreshGroupVisibility()
    this._lastProjectId = this.projectId
    const projectInput = this.element.querySelector('input[type="hidden"][name="form[project_id]"]')
    if (projectInput) projectInput.addEventListener('change', () => this.projectChanged())
  }

  get projectId () {
    return this.element.querySelector('input[type="hidden"][name="form[project_id]"]')?.value || ''
  }

  get projectName () {
    return this.element.querySelector('[role="combobox"]')?.value || ''
  }

  projectChanged () {
    if (this.projectId === this._lastProjectId) return
    this._lastProjectId = this.projectId
    if (this.hasProjectNameTarget) this.projectNameTarget.value = this.projectName
    this.notify()
  }

  targetChanged () {
    this.refreshGroupVisibility()
    this.notify()
  }

  refreshGroupVisibility () {
    const target = this.submitTargetTarget.value
    this.todolistGroupTarget.classList.toggle('hidden', target !== 'todolist')
    this.cardColumnGroupTarget.classList.toggle('hidden', target !== 'card_column')
    this.messageBoardGroupTarget.classList.toggle('hidden', target !== 'message_board')
    this.scheduleGroupTarget.classList.toggle('hidden', target !== 'schedule')
  }

  notify () {
    this.dispatch('changed', { detail: { projectId: this.projectId, target: this.submitTargetTarget.value } })
  }
}
